import * as Sentry from '@sentry/react';
import URI from 'jsuri';
import Q from 'q';
import _ from 'underscore';

import API from 'js/lib/api';

import { EOI_ACTIONS } from 'bundles/expression-of-interest/constants';
import { getEoiContext, logFlowCompleteAction } from 'bundles/expression-of-interest/utils/util';
import type { ValidationErrors } from 'bundles/premium-hub/types';
import { validateResponse } from 'bundles/survey-form/utils/ValidationUtils';

const QualificationSurveyResponseAPI = API('/api/qualificationSurveySectionResponses.v2/', { type: 'rest' });

/**
 * Calls window.document (do not execute on server-side)
 */
const createOrUpdateQualificationSurvey = (
  productId: $TSFixMe,
  sectionId: $TSFixMe,
  responses: $TSFixMe,
  responseId: $TSFixMe
) => {
  const uri = new URI().addQueryParam('action', 'createOrUpdate').addQueryParam('productId', productId);
  let eoiContext = {};

  if (responseId) uri.addQueryParam('responseId', responseId);

  try {
    eoiContext = getEoiContext(document.location.href);
  } catch (e) {
    Sentry.captureException(e);
  }

  const data = { sectionId, responses, eoiContext };

  return Q(QualificationSurveyResponseAPI.post(uri.toString(), { data }));
};

const previewQualificationSurveyResponse = (productId: $TSFixMe) => {
  const uri = new URI().addQueryParam('action', 'previewStartSection').addQueryParam('productId', productId);
  return Q(QualificationSurveyResponseAPI.post(uri.toString()));
};

const initializeQualificationSurvey = (actionContext: $TSFixMe, { productId, onSuccess }: $TSFixMe) => {
  previewQualificationSurveyResponse(productId)
    .then((response) => {
      if (onSuccess) {
        onSuccess(response);
      }
    })
    .done();
};

const submitResponse = (
  actionContext: $TSFixMe,
  {
    productId,
    sectionData,
    userInput,
    onSuccess,
    onError,
    logAction,
  }: {
    productId: string;
    sectionData: $TSFixMe;
    userInput: $TSFixMe;
    onSuccess: (response: $TSFixMe) => void;
    onError: (validationErrors: ValidationErrors) => void;
    logAction?: (action: string, metadata?: Record<string, string>, hasError?: boolean) => void;
  }
) => {
  let validationErrors: ValidationErrors = {};
  if (sectionData.typeName !== 'terminalData') {
    validationErrors = validateResponse(sectionData, userInput);
  }

  if (_(validationErrors).isEmpty()) {
    logAction?.(EOI_ACTIONS.POST_START);
    createOrUpdateQualificationSurvey(productId, sectionData.sectionId, userInput, sectionData.requestId)
      .then((response) => {
        logFlowCompleteAction(productId, logAction);
        onSuccess(response);
      })
      .catch((e) => {
        logAction?.(EOI_ACTIONS.POST_ERROR);
        Sentry.captureException(e);
      })
      .done();
  } else {
    onError(validationErrors);

    const metadata = {
      hasInvalidPhoneNumber: (!!validationErrors?.phoneNumber).toString(),
      hasInvalidDegreeTrack: (!!validationErrors?.degreeTrack).toString(),
      hasInvalidCategoriesSelection: (!!validationErrors?.categoriesSelection).toString(),
    };

    logAction?.(EOI_ACTIONS.VALIDATION_ERROR, metadata);
  }
};

const exported = {
  initializeQualificationSurvey,
  submitResponse,
};

export default exported;
export { initializeQualificationSurvey, submitResponse };
